import { createContext, useContext } from 'react'
import type { LocalQueryChatController } from '../artifacts/localQueryAssistant'

export interface LocalQueryContext {
  id?: string
  name: string
  assistant?: LocalQueryChatController
  returnToFile: () => void
}

/** A mounted code canvas can request room without changing other application pages. */
export const CodeWorkspaceLayoutContext = createContext({
  codeWorkspace: false,
  setCodeWorkspace: (_active: boolean) => {},
  localQuery: null as LocalQueryContext | null,
  setLocalQuery: (_query: LocalQueryContext | null) => {},
})

export const useCodeWorkspaceLayout = () => useContext(CodeWorkspaceLayoutContext)
